export default "__VITE_ASSET__D2ZGEc3B__"